import { observable, action, runInAction } from 'mobx'
import React from 'react'
import Api from '@api/xiu_yan/jukeTreasureApi'
import { toTimestamp } from '@hlj/hlj-utils'
import { MERCHANT_CONSULT_PHONE } from '@hlj/hlj-constant'
import { message, Modal } from 'hljd'
class Store {
  @observable id
  @observable type
  @observable list = []
  @observable loading = false
  @observable
  pagination = {
    current: 1,
    pageSize: 20,
    total: 0
  }

  @action
  setPage = page => {
    this.pagination.current = page.current
    this.getList(page.current)
  }

  @observable timer
  @observable d = 0
  @observable h = 0
  @observable m = 0
  @observable s = 0
  @observable activity = {}
  @action
  getList = async page => {
    this.loading = true
    const { pagination, id, searchVal } = this
    const { data } = await Api.getEnrollList({
      per_page: 20,
      page: page ? page : pagination.current,
      id,
      search_key: searchVal
    })
    const { apply } = data || {}
    runInAction(() => {
      this.activity = Object.assign({}, data, {
        sign_up_count: apply.total_count || 0
      })
      this.list = apply.list || []
      this.loading = false
      this.pagination = Object.assign({}, this.pagination, {
        total: apply.total_count * 1
      })
      this.timer = setInterval(() => {
        let end = toTimestamp(this.activity.end_date)
        let now = toTimestamp()
        let rest = end - now

        if (rest > 0) {
          this.d = parseInt(rest / 1000 / 60 / 60 / 24)
          this.h =
            parseInt((rest / 1000 / 60 / 60) % 24) > 9
              ? parseInt((rest / 1000 / 60 / 60) % 24)
              : '0' + parseInt((rest / 1000 / 60 / 60) % 24)
          this.m =
            parseInt((rest / 1000 / 60) % 60) > 9
              ? parseInt((rest / 1000 / 60) % 60)
              : '0' + parseInt((rest / 1000 / 60) % 60)
          this.s =
            parseInt((rest / 1000) % 60) > 9
              ? parseInt((rest / 1000) % 60)
              : '0' + parseInt((rest / 1000) % 60)
        } else {
          clearInterval(this.timer)
          return false
        }
      }, 1000)
    })
  }

  @observable remark = ''
  @action
  changeRemark = e => {
    this.remark = e.target.value
  }

  @observable remarkId
  @observable remarkVisible = false
  @action
  showRemarkModal = (value, id) => () => {
    this.remark = value
    this.remarkId = id
    this.remarkVisible = true
  }

  @action
  hideRemarkModal = () => {
    this.remark = ''
    this.remarkId = ''
    this.remarkVisible = false
  }

  @action
  addRemark = async () => {
    const { remark, remarkId } = this
    let params = {
      remark,
      customer_id: remarkId
    }
    let { success } = await Api.operateRecord(params)
    if (success) {
      message.success('操作成功！')
      this.hideRemarkModal()
      this.getList()
    }
  }
  @observable searchVal = ''
  @action
  changeSearchVal = e => {
    this.searchVal = e.target.value
  }

  @observable luckStatus = ''
  @action
  changeLuckStatus = value => {
    this.luckStatus = value
    this.getList()
  }

  @observable presentStatus = ''
  @action
  changePresentStatus = value => {
    this.presentStatus = value
    this.getList()
  }
  showTips = () => {
    Modal.info({
      iconType: 'none',
      title: '活动点不足，充值活动点后可联系用户',
      content: (
        <div style={{ color: '#f83244', fontSize: 16 }}>
          请联系客服（{MERCHANT_CONSULT_PHONE}）处理
        </div>
      )
    })
  }
  @action
  initParams = (id, type) => {
    this.id = id
    this.type = type
  }
}
export default Store
